import { render, staticRenderFns } from "./PgaTransition.vue?vue&type=template&id=054832bf&"
import script from "./PgaTransition.vue?vue&type=script&lang=ts&"
export * from "./PgaTransition.vue?vue&type=script&lang=ts&"
import style0 from "./PgaTransition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('054832bf')) {
      api.createRecord('054832bf', component.options)
    } else {
      api.reload('054832bf', component.options)
    }
    module.hot.accept("./PgaTransition.vue?vue&type=template&id=054832bf&", function () {
      api.rerender('054832bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PgaTransition.vue"
export default component.exports